module.exports = __webpack_public_path__ + "img/linkedin.631b864.svg";